export default __webpack_public_path__ + "static/media/valleyCourt.c4c47821.jpeg";